module.exports = __webpack_public_path__ + "media/images/emblems/Perrefitte-coat_of_arms-658104ed8d0140385cac08fe796ad9f4.svg";